"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useFilterIds = _interopRequireDefault(require("../hooks/useFilterIds"));
var _useConnectFilterIdEffect = _interopRequireDefault(require("../hooks/useConnectFilterIdEffect"));
var COUNT_OF_FILTERS = [0, 1, 2, 3, 4];
var SvgFilters = function SvgFilters(_ref) {
  var baseFrequency = _ref.baseFrequency,
    scaleNoise = _ref.scaleNoise,
    rootRef = _ref.rootRef;
  var filterIds = (0, _useFilterIds.default)(COUNT_OF_FILTERS, {
    baseFrequency: baseFrequency,
    scaleNoise: scaleNoise
  });
  (0, _useConnectFilterIdEffect.default)(COUNT_OF_FILTERS, {
    rootRef: rootRef,
    filterIds: filterIds
  });
  var renderFilter = (0, _react.useCallback)(function (i) {
    return /*#__PURE__*/_react.default.createElement("filter", {
      id: filterIds[i],
      key: String(i)
    }, /*#__PURE__*/_react.default.createElement("feTurbulence", {
      baseFrequency: baseFrequency,
      type: "turbulence",
      numOctaves: "3",
      result: "noise",
      seed: i
    }), /*#__PURE__*/_react.default.createElement("feDisplacementMap", {
      in2: "noise",
      in: "SourceGraphic",
      scale: scaleNoise
    }));
  }, [baseFrequency, scaleNoise]);
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: "glitch-squiggly__svg-filters",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1"
  }, /*#__PURE__*/_react.default.createElement("defs", null, COUNT_OF_FILTERS.map(renderFilter)));
};
var _default = /*#__PURE__*/(0, _react.memo)(SvgFilters);
exports.default = _default;
SvgFilters.propTypes = {
  baseFrequency: _propTypes.default.number,
  scaleNoise: _propTypes.default.number,
  rootRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })])
};